import React from "react";
import ReactDOM from "react-dom";
import "antd/dist/antd.css";
import { Table, Button, Pagination, Space, message, Empty } from "antd";
import ReportCell from "../Cell/ReportCell";
import SignatureCell from "../Cell/SignatureCell";
import moment from "moment";
import * as actions from "../../../../../store/actions/indexes";
import { connect } from "react-redux";
import _, { indexOf } from "lodash";
import HotelNavigation from "../Navigation/HotelNavigation";
import CustomHeaderWithTooltip from "../../../Common/EnduserTooltip/index";
import {
  RightSquareOutlined,
  LeftSquareOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";
import commonConfig from "../../../../commonConfig.json";

let customTabView = commonConfig.customTabView;

class VerticalTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isVisibleToolTip: false,
      columns: [],
      data: [],
      winWidth: window.innerWidth,
      winHeight: window.innerHeight,
      // selectedHotels: [],
      // currentViewIndexes: this.props.settings.indexes
    };
    this.hideOnTrigger = this.hideOnTrigger.bind(this);
    this.renderTable = this.renderTable.bind(this);
    this.changeHotelView = this.changeHotelView.bind(this);
    this.updateDimensions = this.updateDimensions.bind(this);
  }

  updateDimensions = () => {
    this.setState({
      winWidth: window.innerWidth,
      // winHeight: window.innerHeight
    });
  };

  componentDidMount() {
    window.addEventListener("resize", () => this.updateDimensions());
  }

  componentWillUnmount() {
    window.removeEventListener("resize", () => this.updateDimensions());
  }
  componentDidUpdate(prevProps) {
    // console.log("DATA_CHANGE", this.props.complianceData.length , prevProps.complianceData.length)
    if (
      this.props.qmsApi.complianceTableData[this.props.customTabView] !==
        prevProps.qmsApi.complianceTableData[this.props.customTabView] ||
      this.props.status !== prevProps.status ||
      this.props.customTabView !== prevProps.customTabView
    ) {
      // || this.props.qmsApi.customTabViewComplianceTableData !== prevProps.qmsApi.customTabViewComplianceTableData)
      this.renderTable();
    }
  }

  hideOnTrigger = (value) => {
    this.setState({ isVisibleToolTip: value });
  };

  // this method will render the table columns headers and feeding main datasource array(row records data)
  renderTable = () => {
    var default_report_type_view = this.props.status;
    let complianceData = [];
    // if(this.props.customTabView === customTabView.CUSTOM){
    //   complianceData = this.props.qmsApi.customTabViewComplianceTableData;
    // } else {
    //   complianceData = this.props.qmsApi.complianceTableData;
    // }
    complianceData =
      this.props.qmsApi.complianceTableData[this.props.customTabView] !==
      undefined
        ? this.props.qmsApi.complianceTableData[this.props.customTabView]
        : [];
    if (complianceData.length != 0) {
      var _data = [];
      var _columns = [];
      var hotel_item = complianceData[0];

      hotel_item.forEach((i) => {
        var temp_item_0_key = _.keys(i)[0];
        var column_hotel_template = {
          title: temp_item_0_key,
          width: 200,
          dataIndex: "report_signature_status_" + temp_item_0_key,
          key: temp_item_0_key,
          render: (params) => {
            return <div>{params}</div>;
          },
        };

        _columns.push(column_hotel_template);
      });

      //console.log('settings =',this.props.settings);
      for (var i = 0; i < complianceData.length; i++) {
        var rows = complianceData[i];
        var item = rows[0];
        var key = _.keys(item)[0];
        var record_obj_reports = {};
        var record_obj_signature = {};
        // let _state = this.state;
        // let _this = this;

        if (default_report_type_view == "All") {
          // console.log(item[key].reports, "item[key].reports")
          item[key].reports.forEach((val) => {
            let tempHotel =
              (val.hotelCode != "" && val.hotel != ""
                ? val.hotelCode + " - " + val.hotel
                : val.hotelEnv === "Marriott"
                ? val.hotelCode
                : val.hotel) +
              (val.qcType !== "" ? " (" + val.qcType + ")" : "");
            let header = tempHotel;
            if (val.softLiveStyle) {
              header = (
                <>
                  {tempHotel}{" "}
                  <span
                    style={{
                      color: "black",
                      float: "right",
                      paddingRight: "10px",
                      paddingLeft: "10px",
                    }}
                  >
                    {" "}
                    Soft Live
                  </span>
                </>
              );
            }

            const main_items_report = {
              key: val.hotel + "_Report_" + i,
              hotel: header,
              hotelName: tempHotel,
              reportType: {
                title: (
                  <div style={{ textAlign: "center", fontWeight: "600" }}>
                    <CustomHeaderWithTooltip
                      title={"Report Status"}
                      visible={this.state.isVisibleToolTip}
                      onHide={this.hideOnTrigger}
                    />
                  </div>
                ),
                prop: null,
                softLive: val.softLiveStyle || {},
              },
              softLive: val.softLiveStyle || {},
            };

            rows.forEach((e) => {
              const temp_key = _.keys(e)[0];
              const _key = "report_signature_status_" + temp_key;
              record_obj_reports[_key] = (
                <ReportCell
                  mydocsURL={e[temp_key].reports[0].mydocsRedirectUrl}
                  reportContent={{
                    mis_reports: e[temp_key].reports[0].missingReportList,
                    up_reports: e[temp_key].reports[0].uploadedReportList,
                  }}
                  status={e[temp_key].reports[0].reportCell}
                  idKey={
                    e[temp_key].reports[0].hotel +
                    ":" +
                    e[temp_key].reports[0].date +
                    ":" +
                    e[temp_key].reports[0].hotelEnv +
                    ":" +
                    e[temp_key].reports[0].hotelCode
                  }
                />
              );
            });

            const _report_container = {
              ...main_items_report,
              ...record_obj_reports,
            };

            _data.push(_report_container);
          });

          item[key].reports.forEach((val) => {
            let tempHotel =
              (val.hotelCode != "" && val.hotel != ""
                ? val.hotelCode + " - " + val.hotel
                : val.hotelEnv === "Marriott"
                ? val.hotelCode
                : val.hotel) +
              (val.qcType !== "" ? " (" + val.qcType + ")" : "");
            let header = tempHotel;
            if (val.softLiveStyle) {
              header = (
                <>
                  {header}{" "}
                  <span
                    style={{
                      color: "black",
                      float: "right",
                      paddingRight: "10px",
                      paddingLeft: "10px",
                    }}
                  >
                    {" "}
                    Soft Live
                  </span>
                </>
              );
            }

            const main_items_signature = {
              key: val.hotel + "_Signature_" + i,
              hotel: header,
              hotelName: tempHotel,
              reportType: {
                title: "Signature Status",
                prop: (
                  <div
                    style={
                      val.softLiveStyle
                        ? val.softLiveStyle
                        : { textAlign: "center" }
                    }
                  >
                    <CustomHeaderWithTooltip
                      title={"Signature Status"}
                      visible={this.state.isVisibleToolTip}
                      onHide={this.hideOnTrigger}
                    />
                  </div>
                ),
                softLive: val.softLiveStyle || {},
              },
              softLive: val.softLiveStyle || {},
            };

            rows.forEach((e) => {
              const temp_key = _.keys(e)[0];
              const _key = "report_signature_status_" + temp_key;
              record_obj_signature[_key] = (
                <SignatureCell
                  mydocsURL={e[temp_key].reports[0].mydocsSigRedirectUrl}
                  signContnent={e[temp_key].reports[0].signatureDetails}
                  reportContent={{
                    mis_reports: e[temp_key].reports[0].missingReportList,
                    up_reports: e[temp_key].reports[0].uploadedReportList,
                  }}
                  status={e[temp_key].reports[0].signatureCell}
                  basicCellData={{
                    hmg: e[temp_key].reports[0].hmg,
                    hotelEnv: e[temp_key].reports[0].hotelEnv,
                    bdate: e[temp_key].reports[0].date,
                  }}
                  idKey={
                    e[temp_key].reports[0].hotel +
                    ":" +
                    e[temp_key].reports[0].date +
                    ":" +
                    e[temp_key].reports[0].hotelEnv +
                    ":" +
                    e[temp_key].reports[0].hotelCode
                  }
                />
              );
            });

            const _signature_container = {
              ...main_items_signature,
              ...record_obj_signature,
            };
            _data.push(_signature_container);
          });
        } else if (default_report_type_view == "Report Status") {
          item[key].reports.forEach((val) => {
            let tempHotel =
              (val.hotelCode != "" && val.hotel != ""
                ? val.hotelCode + " - " + val.hotel
                : val.hotelEnv === "Marriott"
                ? val.hotelCode
                : val.hotel) +
              (val.qcType !== "" ? " (" + val.qcType + ")" : "");
            let header = tempHotel;
            if (val.softLiveStyle) {
              header = (
                <>
                  {tempHotel}{" "}
                  <span
                    style={{
                      color: "black",
                      float: "right",
                      paddingRight: "10px",
                      paddingLeft: "10px",
                    }}
                  >
                    {" "}
                    Soft Live
                  </span>
                </>
              );
            }

            rows.forEach((e) => {
              const temp_key = _.keys(e)[0];
              const _key = "report_signature_status_" + temp_key;
              record_obj_reports[_key] = (
                <ReportCell
                  mydocsURL={e[temp_key].reports[0].mydocsRedirectUrl}
                  reportContent={{
                    mis_reports: e[temp_key].reports[0].missingReportList,
                    up_reports: e[temp_key].reports[0].uploadedReportList,
                  }}
                  status={e[temp_key].reports[0].reportCell}
                  idKey={
                    e[temp_key].reports[0].hotel +
                    ":" +
                    e[temp_key].reports[0].date +
                    ":" +
                    e[temp_key].reports[0].hotelEnv +
                    ":" +
                    e[temp_key].reports[0].hotelCode
                  }
                />
              );
            });
            const main_items_report = {
              key: val.hotel + "_Report_" + i,
              hotel: header,
              hotelName: tempHotel,
              reportType: {
                title: (
                  <div
                    style={
                      val.softLiveStyle
                        ? val.softLiveStyle
                        : { textAlign: "center", fontWeight: "600" }
                    }
                  >
                    <CustomHeaderWithTooltip
                      title={"Report Status"}
                      visible={this.state.isVisibleToolTip}
                      onHide={this.hideOnTrigger}
                    />
                  </div>
                ),
                prop: null,
                softLive: val.softLiveStyle || {},
              },
              softLive: val.softLiveStyle || {},
            };
            const _report_container = {
              ...main_items_report,
              ...record_obj_reports,
            };
            _data.push(_report_container);
          });
        } else if (default_report_type_view == "Signature Status") {
          item[key].reports.forEach((val) => {
            let tempHotel =
              (val.hotelCode != "" && val.hotel != ""
                ? val.hotelCode + " - " + val.hotel
                : val.hotelEnv === "Marriott"
                ? val.hotelCode
                : val.hotel) +
              (val.qcType !== "" ? " (" + val.qcType + ")" : "");
            let header = tempHotel;
            if (val.softLiveStyle) {
              header = (
                <>
                  {tempHotel}{" "}
                  <span
                    style={{
                      color: "black",
                      float: "right",
                      paddingRight: "10px",
                      paddingLeft: "10px",
                    }}
                  >
                    {" "}
                    Soft Live
                  </span>
                </>
              );
            }

            const main_items_signature = {
              key: val.hotel + "_Signature_" + i,
              hotel: header,
              hotelName: tempHotel,
              reportType: {
                title: "Signature Status",
                prop: (
                  <div
                    style={
                      val.softLiveStyle
                        ? val.softLiveStyle
                        : { textAlign: "center", fontWeight: "600" }
                    }
                  >
                    <CustomHeaderWithTooltip
                      title={"Signature Status"}
                      visible={this.state.isVisibleToolTip}
                      onHide={this.hideOnTrigger}
                    />
                  </div>
                ),
                softLive: val.softLiveStyle || {},
              },
              softLive: val.softLiveStyle || {},
            };
            rows.forEach((e) => {
              const temp_key = _.keys(e)[0];
              const _key = "report_signature_status_" + temp_key;
              record_obj_signature[_key] = (
                <SignatureCell
                  mydocsURL={e[temp_key].reports[0].mydocsSigRedirectUrl}
                  signContnent={e[temp_key].reports[0].signatureDetails}
                  reportContent={{
                    mis_reports: e[temp_key].reports[0].missingReportList,
                    up_reports: e[temp_key].reports[0].uploadedReportList,
                  }}
                  status={e[temp_key].reports[0].signatureCell}
                  basicCellData={{
                    hmg: e[temp_key].reports[0].hmg,
                    hotelEnv: e[temp_key].reports[0].hotelEnv,
                    bdate: e[temp_key].reports[0].date,
                  }}
                  idKey={
                    e[temp_key].reports[0].hotel +
                    ":" +
                    e[temp_key].reports[0].date +
                    ":" +
                    e[temp_key].reports[0].hotelEnv +
                    ":" +
                    e[temp_key].reports[0].hotelCode
                  }
                />
              );
            });

            const _signature_container = {
              ...main_items_signature,
              ...record_obj_signature,
            };

            _data.push(_signature_container);
          });
        }
      }

      // if(this.state.winWidth < 768){
      //   this.setState(state => {
      //     const report_type = {
      //       title: "",
      //       width: 150,
      //       dataIndex: "reportType",
      //       key: "reportType",
      //       // fixed: 'left',
      //       render: (cell, row) => {
      //         if (cell['title'] === 'Signature Status') {
      //           return {
      //             children: cell.prop,
      //             props: {
      //               style: cell.softLive
      //             }
      //           }
      //         } else {
      //           return {
      //             children: cell.title,
      //             props: {
      //               style: cell.softLive
      //             }
      //           }
      //         }

      //       }
      //     }
      //     _columns.unshift(report_type);
      //     const hotel_column = {
      //       title: "Hotel",
      //       width: 150,
      //       dataIndex: "hotel",
      //       key: "hotel",
      //       fixed: 'left',
      //       render(_, row) {
      //         return {
      //           children: row.hotel,
      //           props: {
      //             rowSpan: row.rowSpan,
      //             style: { ...row.softLive }
      //           }
      //         }
      //       }
      //     }

      //     _columns.unshift(hotel_column);
      //     _data = this.mergeCells(_data);

      //     return {
      //       columns: _columns,
      //       data: _data
      //     }
      //   })
      // } else {
      this.setState((state) => {
        const report_type = {
          title: "",
          width: 150,
          dataIndex: "reportType",
          key: "reportType",
          fixed: "left",
          render: (cell, row) => {
            if (cell["title"] === "Signature Status") {
              return {
                children: cell.prop,
                props: {
                  style: cell.softLive,
                },
              };
            } else {
              return {
                children: cell.title,
                props: {
                  style: cell.softLive,
                },
              };
            }
          },
        };
        _columns.unshift(report_type);
        const hotel_column = {
          title: "Hotel",
          width: 150,
          dataIndex: "hotel",
          key: "hotel",
          fixed: "left",
          render(_, row) {
            return {
              children: row.hotel,
              props: {
                rowSpan: row.rowSpan,
                style: { ...row.softLive },
              },
            };
          },
        };

        _columns.unshift(hotel_column);
        _data = this.mergeCells(_data);

        return {
          columns: _columns,
          data: _data,
        };
      });
      // }
    } else {
      // message.error("There is no valid compliance data to proceed");
      this.setState({
        columns: [],
        data: [],
      });
    }
  };

  mergeCells(data) {
    return data
      .reduce((result, item) => {
        //First, take the hotel field as a new array result
        if (result.indexOf(item.hotelName) < 0) {
          result.push(item.hotelName);
        }
        return result;
      }, [])
      .reduce((result, hotel) => {
        //Take the data with the same hotel as a new array, and add a new field * * rowSpan inside it**
        const children = data.filter((item) => item.hotelName === hotel);

        result = result.concat(
          children.map((item, index) => ({
            ...item,
            rowSpan: index === 0 ? children.length : 0, //Add the first row of data to the rowSpan field
          }))
        );

        return result;
      }, []);
  }

  statusOnClick = () => {
    //console.log('status onclick');
  };

  showTotal = (total) => {
    return `${total} of hotels`;
  };

  changeHotelView = (value) => {
    this.props.changeHotelView(value);
  };

  render() {
    return (
      <div>
        <Table
          className="complianceTable"
          columns={this.state.columns}
          dataSource={this.state.data}
          bordered
          pagination={false}
          size={this.state.winWidth < 768 ? "small" : "middle"}
          tableLayout="fixed"
          // size="middle"
          id="compDatatableV"
          key="compDatatableV"
          locale={{
            emptyText: (
              <Empty
                image={Empty.PRESENTED_IMAGE_SIMPLE}
                description="No File Found"
              />
            ),
          }}
          // scroll={{ x: "calc(300px + 50%)", y: 540 }}
          // scroll={{ x: 1000, y: 540 }}
          scroll={{
            x:
              this.state.winWidth >= 1200
                ? 1000
                : this.state.winWidth >= 768
                ? 500
                : "max-content",
            y: 540,
          }}
        />
        <HotelNavigation
          settings={this.props.settings}
          changeHotelViewEvent={this.changeHotelView}
          // selectedHotels={this.props.selectedHotels}
          // emptyData={this.props.customTabView !== customTabView.DEFAULT ? this.props.qmsApi.customTabViewComplianceTableData.length : this.props.qmsApi.complianceTableData.length}
          emptyData={
            this.props.qmsApi.complianceTableData[this.props.customTabView] !==
            undefined
              ? this.props.qmsApi.complianceTableData[this.props.customTabView]
                  .length
              : 0
          }
        />
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    qmsApi: state.qmsApi,
    status: state.complianceTableReducer.status,
    customTabView: state.appPermissionsReducer.complianceMainTabData.active,
    // customTabView:state.complianceTableReducer.customTabView,
  };
};

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(VerticalTable);
